(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.shell:mxActionsDropdown
	 * @module mx.shell
	 * @requires {@ref mx.shell.ActionManagerService mx.shell.ActionManagerService}
	 * @description A dropdown with list of actions
	 * @param {mx.shell.Action} actions= - List of {@ref mx.shell.Action Actions}
	 * @param context= - context
	 * @usage <mx-actions-dropdown actions='actions'></mx-actions-dropdown>
	 */

	angular.module('mx.shell').component('mxActionsDropdown', {
		bindings: {
			icon: '@',
			actions: '=',
			context: '=',
			dropdownHtmlClass: '@?',
		},
		controller: MxActionsDropdownCtrl,
		controllerAs: 'vm',
		templateUrl: 'components/mx-actions-dropdown/mx-actions-dropdown.html',
	});

	MxActionsDropdownCtrl.$inject = ['mx.shell.ActionExecutorService'];

	function MxActionsDropdownCtrl(actionExecutorService) {
		var vm = this;

		vm.$onInit = function () {
			vm.icon = vm.icon || 'more_horiz';
		};

		vm.executeAction = function (action) {
			var selectedObjects = vm.context ? [vm.context] : undefined;

			actionExecutorService.execute(action, selectedObjects).catch(mx.logCatch);
		};
	}
})();
